import { FC } from "react";
import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";
import { useRecoilValue } from "recoil";

import { RideStationContext, useRideStation } from "@ryde/redux";
import {
  errorAndToastSimpleResult,
  getStationComposedId,
  isCollapsedRideStationSF,
  IStationRideProps,
  useIsMobile,
} from "@ryde/shared";

import { RideStationPassengerRow } from "./ride-station-passenger.row";
import { RideStationRow } from "./ride-station-row";
import { RideStationStyled } from "./ride-stations.styled";

export const RideStationGreyed: FC<IStationRideProps> = props => {
  const { station, rideDto } = props;
  const { isMobile } = useIsMobile();
  const { t } = useTranslation();

  const isCollapsed = useRecoilValue(
    isCollapsedRideStationSF([rideDto.id || 0, station.id]),
  );

  const rideStationHookData = useRideStation(props);

  const { removeSelectedPassengersFromRide, stationPassengers } =
    rideStationHookData;

  const deletePassenger = useEvent(
    async (
      e: React.MouseEvent,
      hoverPassId?: number | undefined,
    ): Promise<void> => {
      const result = await removeSelectedPassengersFromRide(hoverPassId);

      if (!result.success) {
        errorAndToastSimpleResult(result, t);
      }
    },
  );

  return (
    <RideStationContext.Provider
      value={{
        ...props,
        ...rideStationHookData,
        rideDto,
        isDragging: false,
        listeners: undefined,
        attributes: undefined,
        isStationDraggable: false,
      }}
    >
      <RideStationStyled
        $isDragging={false}
        $isDragClone={false}
        data-e2e-id={getStationComposedId(station)}
        ref={null}
      >
        <RideStationRow />
        {(!isCollapsed || isMobile) &&
          stationPassengers.map(pass => (
            <RideStationPassengerRow
              key={pass.id}
              passenger={pass}
              station={station}
              rideDto={rideDto}
              deletePassengerHandler={deletePassenger}
            />
          ))}
      </RideStationStyled>
    </RideStationContext.Provider>
  );
};
